const recentViewContainerElem = document.querySelector('.section-recently-viewed'); 
const recentViewListElem = document.querySelector('.product-recent-list');
function prepRecView(inpFexp){
  recentViewContainerElem.classList.add('active'); // show section //
  let recentViewListItemHtml = recentViewListElem.querySelector('.clone-tpl').innerHTML;
  for (let rv = 1; rv < inpFexp; rv++) { // clone list item //
    recentViewListElem.innerHTML += '<li class="product-recent-list--item placeholder" data-recentIndex="' + rv + '">' + recentViewListItemHtml + '</li>';
  }
}
function setRecViewProd(inpFandle, inpIndex){
  if(inpFandle != ''){
    let recentSetViewPref = '/products/';
    if(main_globlang != 'en'){
        recentSetViewPref = '/' + main_globlang + recentSetViewPref;
    }
    let recentSetViewPushUrl = recentSetViewPref + inpFandle;
    let recentSetViewFetchUrl = recentSetViewPushUrl + '?view=recentview';
    let recentSetViewFetchIndex = inpIndex;
    let recentSetViewFetchObject = {
        method: 'GET', recentSetViewPushInd: inpIndex, recentSetViewPushUri: recentSetViewPushUrl,
    };
    let recentSetViewRequest = fetch(recentSetViewFetchUrl, recentSetViewFetchObject).then(function (recentSetViewResponse){
        let recentSetViewResponseStatus = recentSetViewResponse.status;
        if(recentSetViewResponseStatus == '200'){
            return recentSetViewResponse.text();
        }
    }).then(function(recentSetViewResponseHtml) {
        let recentSetViewInsertElem = recentViewListElem.querySelector('[data-recentIndex="'+recentSetViewFetchObject.recentSetViewPushInd+'"]');
        if(recentSetViewResponseHtml == undefined){
          recentSetViewInsertElem.classList.add('notfound');
        } else {
          let recentSetViewPrepHtml = recentSetViewResponseHtml.replace('href="#"','href="' + recentSetViewFetchObject.recentSetViewPushUri + '" data-quickshop="'+recentSetViewFetchObject.recentSetViewPushUri+'?view=quickshop" ');
          recentSetViewInsertElem.innerHTML = recentSetViewPrepHtml;
          recentSetViewInsertElem.classList.add('active');
          recentSetViewInsertElem.classList.remove('placeholder');
        }
    }).catch(function (err) {
        console.log("Something went wrong!", err);
    });
  }
}
function getRecView(){
  // get prods recent from cookie //
  let recentGetViewProdStr = bGetCookie(recentViewRecCookie);
  let recentGetViewProdArr = [];
  let recentGetViewProdCount = 0;
  if(recentGetViewProdStr.length > 0){
    recentGetViewProdArr = recentGetViewProdStr.split(',');
    recentGetViewProdCount = recentGetViewProdArr.length;
    prepRecView(recentGetViewProdCount); // prep recent view //
    recentGetViewProdArr.forEach(setRecViewProd); // load prod data //
  } 
}
getRecView();